import * as React from "react";

import type { CampaignRequestDetail, CampaignRequestEvent } from "@/hooks/api/use-campaign-requests";

import { Panel } from "./parts";
import { RequestTimeline } from "./request-timeline";

/**
 * Everything that has happened to this request, and what is still ahead of it — in the client's
 * own words. UX §12 note 1: "Building your agents — 2 of 3 done", never `in_preparation`. The
 * state machine sits behind the copy and no state name reaches this list.
 */

export interface ActivityTabProps {
	request: CampaignRequestDetail;
	events: CampaignRequestEvent[];
	isLoading?: boolean;
}

export function ActivityTab({ request, events, isLoading = false }: ActivityTabProps): React.JSX.Element {
	return (
		<Panel title="Activity">
			<RequestTimeline request={request} events={events} isLoading={isLoading} />
		</Panel>
	);
}
